import { Injectable } from '@angular/core';
import { ICustomerCondition } from 'src/app/shared/interfaces/customer-condition.interface';

@Injectable({
  providedIn: 'root'
})
export class CustomerDataService {
  public customerConditionData: ICustomerCondition = {} as ICustomerCondition;

  get customerData(): ICustomerCondition {
    return this.customerConditionData;
  }

  set customerData(data: ICustomerCondition) {
    this.customerConditionData = data;
  }
}
